import React, { useEffect, useState } from 'react';
import { api } from '../context/AuthContext';

export const sourceLabel = s => `${s.title || 'Başlık belirtilmemiş'} · ${s.source_type === 'book' ? 'Kitap' : 'Video'} · ${s.source_id}`;

export default function ReviewSourcePicker({ selected, onSelect, disabled }) {
  const [q, setQ] = useState(''), [offset, setOffset] = useState(0);
  const [items, setItems] = useState([]), [more, setMore] = useState(false);
  const [loading, setLoading] = useState(false), [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setLoading(true); setItems([]); setMore(false); setError('');
    const timer = setTimeout(async () => {
      try {
        const response = await api.get('/mahmut/review/sources', { params: { q, offset, limit: 50 } });
        if (active) { setItems(response.data.items); setMore(response.data.has_more); }
      } catch { if (active) setError('Kaynaklar getirilemedi. Aramayı yeniden deneyin.'); }
      finally { if (active) setLoading(false); }
    }, 250);
    return () => { clearTimeout(timer); active = false; };
  }, [q, offset]);
  const style = { background: 'var(--sy-panel)', color: 'var(--sy-text)', minHeight: 44 };
  return <section aria-label="Kaynak seçimi" className="my-4">
    <label className="block my-4">Kaynak ara<input type="search" maxLength={200} value={q} onChange={e => { setQ(e.target.value); setOffset(0); }} placeholder="Başlık veya kaynak kimliği" className="block w-full border rounded-xl p-3" style={style} /></label>
    <p role="status">{loading ? 'Kaynaklar aranıyor…' : error || `${items.length} kaynak bu sayfada${more ? '; devamı var' : ''}.`}</p>
    <label className="block my-4">Kaynak<select value={selected?.source_id || ''} disabled={disabled || loading} onChange={e => onSelect(items.find(s => s.source_id === e.target.value) || null)} className="block w-full border rounded-xl p-3" style={style}>
      <option value="">Kaynak seçin</option>
      {selected && !items.some(s => s.source_id === selected.source_id) && <option value={selected.source_id}>{sourceLabel(selected)}</option>}
      {items.map(s => <option key={s.source_id} value={s.source_id}>{sourceLabel(s)}</option>)}
    </select></label>
    <div className="flex flex-wrap gap-3">
      <button type="button" className="border rounded-xl p-3" disabled={disabled || loading || offset === 0} onClick={() => setOffset(Math.max(0, offset - 50))}>Önceki kaynaklar</button>
      <button type="button" className="border rounded-xl p-3" disabled={disabled || loading || !more} onClick={() => setOffset(offset + 50)}>Sonraki kaynaklar</button>
    </div>
    {selected && <p className="my-4 break-words">{sourceLabel(selected)} · Sürüm: {selected.source_revision.slice(0, 12)}</p>}
  </section>;
}
